
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import cssToObjectMixin from '~/mixins/cssToObject'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin, cssToObjectMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },

  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
    imageStyles() {
      const styles = {}

      const imgUrl = this.$img(this.blok.image?.filename, {
        format: 'webp',
        loading: 'lazy',
      })
      styles.background = `url('${imgUrl}') no-repeat center center`
      styles.backgroundSize = 'cover'

      return styles
    },
    overlayStyles() {
      const styles = {}

      const imgUrl = this.$img(this.blok.imageOverlay?.filename, {
        format: 'webp',
        loading: 'lazy',
      })
      styles.background = `url('${imgUrl}') no-repeat center center`
      styles.backgroundSize = 'cover'

      return styles
    },
  },

  methods: {
    onHover() {
      this.$gsap.to(this.$refs.overlay, {
        duration: 0.5,
        opacity: 0,
        ease: 'power2.out',
      })

      this.$gsap.to(this.$refs.image, {
        duration: 0.5,
        scale: 1,
      })
    },
    onLeave() {
      this.$gsap.to(this.$refs.overlay, {
        duration: 0.5,
        opacity: 1,
        overwrite: true,
        ease: 'power2.out',
      })

      this.$gsap.to(this.$refs.image, {
        duration: 0.5,
        scale: 1.2,
      })
    },
  },
}
